import { CheckCircle2, Circle, XCircle } from "lucide-react";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import { cn } from "@/core/utils/utils";
import {
  isPayrollStatementDeliveryFailed,
  isPayrollStatementDeliverySuccessful,
  isTextOnlyDelivery,
} from "./delivery-status-rules";
import type { PayrollStatementNotificationDelivery } from "./types";
import { getDeliveryStatusLabel } from "./utils";

export const DeliveryStatus = ({
  delivery,
}: {
  delivery: PayrollStatementNotificationDelivery | null;
}) => {
  const status = delivery?.status ?? null;
  const isFailed = isPayrollStatementDeliveryFailed(status);
  // A text-only send skips its email on purpose; the PayPack still went out.
  const textOnly = isTextOnlyDelivery(delivery);
  const isSuccessful = textOnly || isPayrollStatementDeliverySuccessful(status);
  const Icon = isFailed ? XCircle : isSuccessful ? CheckCircle2 : Circle;

  return (
    <Stack direction="row" align="center" gap="xs">
      {status ? (
        <Icon
          className={cn("h-4 w-4", {
            "text-red-50": isFailed,
            "text-green-60": isSuccessful,
            "text-tertiary-text": !isFailed && !isSuccessful,
          })}
        />
      ) : (
        <span className="h-2 w-2 rounded-full bg-stroke-secondary" />
      )}
      <Typography
        variant="bodyW3"
        className={cn({
          "text-negative-text": isFailed,
          "text-primary-text": isSuccessful,
          "text-secondary-text": !isFailed && !isSuccessful,
        })}
      >
        {textOnly ? "Sent" : getDeliveryStatusLabel(status)}
      </Typography>
    </Stack>
  );
};
